export default {
  data() {
    return {
      enabledList: [],
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.requestRolePermissions().then(() => {
        vm.requestEnabledList()
      }).catch(() => {
        vm.requestEnabledList()
      })
    })
  },
  methods: {
    requestRolePermissions() {
      var me = this
      return me.$loading({
        url: "/api/ui/role_nav/config",
        method: 'GET',
      }).then(function(res) {
        if (res && res.data) {
          me.filterByRole(me.modules, res.data)
        }
      })
    },
    filterByRole(modules, rolePermissions) {
      for (let i = modules.length - 1; i >= 0; i--) {
        let item = modules[i]
        let matched = rolePermissions.find(e => e.id == item.id)
        if (matched && !matched.enabled) {
          modules.splice(i, 1)
        } else if (item.items) {
          this.filterByRole(item.items, rolePermissions)
          if (item.items.length === 0) {
            modules.splice(i, 1)
          }
        }
      }
    },
    requestEnabledList() {
      var me = this
      me.enabledList = []
      me.$loading({
        url: "/api/ui/co_nav/config",
        method: 'GET',
      }).then(function(res) {
        if(res.data && res.data.length > 0) {
          me.filter(me.modules, res.data)
        }
      })
    },
    doChange(id, enabled) {
      if(!enabled) {
        this.enabledList.push({
          id,
          enabled
        })
      }
      else {
        for(let i = 0; i < this.enabledList.length; i++) {
          if(this.enabledList[i].id === id) {
            this.enabledList.splice(i, 1)
            break
          }
        }
      }
    },
    doUpdate() {
      var me = this
      me.$loading({
        url: "/api/ui/co_nav/config",
        method: 'POST',
        jsonData: me.enabledList
      }).then(function(res) {
        if(res) {
          me.$weui.toast('设置成功', 1000)
        }
        else {
          me.$weui.topTips('设置失败', 1000)
        }
      })
    },
    /* 
      根据不可用列表，把modules对应id的enabled替换成false，并保存在data的enabledList中
    */
    // filter(modules, enabledList) {
    //   var me = this
    //   for(let item of modules){
    //     item.enabled = true
    //     for(let e of enabledList) {
    //       if(item.id === e.id) {
    //         item.enabled = e.enabled
    //         me.enabledList.push(e)
    //       }
    //     }
    //     if(item.items) {
    //       me.filter(item.items, enabledList)
    //     }
    //   }
    // },
    filter(modules, enabledList) {
      var me = this
      for(let item of modules){
        let matched = enabledList.find(e => e.id == item.id);
        if (matched) {
          item.enabled = matched.enabled;
          me.enabledList.push(matched)
        } else {
          item.enabled = true;
        }
        if(item.items) {
          me.filter(item.items, enabledList)
        }
      }
    },
  },
}